import React from "react";
import { Box, Typography } from "@mui/material";

export interface PageHeaderProps {
  /** Titre principal de la page */
  title: string;
  /** Sous-titre optionnel (affiché sous le titre) */
  subtitle?: string;
  /** Icône optionnelle à gauche du titre */
  titleIcon?: React.ReactNode;
  /** Bouton ou action à droite (ex: "Nouveau", "Créer") */
  action?: React.ReactNode;
}

const TITLE_SX = {
  fontSize: "24px",
  fontWeight: 700,
  display: "flex",
  alignItems: "center",
  gap: 1,
  mb: 0.5,
};

const SUBTITLE_SX = {
  fontSize: "14px",
  color: "text.secondary",
};

/**
 * En-tête de page harmonisé (design system).
 * - Titre : 24px, bold, mb: 0.5 (espace avant sous-titre).
 * - Sous-titre : 14px, text.secondary (SUBTITLE_SX).
 * - Action : utiliser le Button du design system avec variant="primary" pour le CTA.
 */
export function PageHeader({
  title,
  subtitle,
  titleIcon,
  action,
}: PageHeaderProps): JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      <Box>
        <Typography variant="h2" sx={TITLE_SX}>
          {titleIcon}
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" sx={SUBTITLE_SX}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Box>
  );
}
